
<script>
import Create from './Create'
export default {
  extends: Create,
  name: 'interactVoteDetail'
}
</script>
<style lang="scss">
// .interact-vote-index-detail{

// }
</style>
